import Col from "react-bootstrap/Col";
import {Link, Route, Switch} from "react-router-dom";
import Row from "react-bootstrap/Row";
import React from "react";
import {logout} from "./KairosEndpoint";

export const Header = ({
	userData,
}) => {
	const banner = (
		<a href = {'https://xeller.info'}
		   target = '_blank'>
			<img src = {'https://xeller.info/wp-content/uploads/2018/03/GX_Logo_9pt_4c_neu.jpg'}
				 height ={'80px'} alt={'Xeller.info Banner'}/>
		</a>
	);

	let topleft;

	if (userData) {
		const onLogout = ev => {
			ev.preventDefault();
			logout()
				.then(() => window.location.assign('/'));
		};

		topleft = (
			<>
				<Col className = {'col-2'}>
					<nav>
						{/* statistics for admins*/}
						{userData.role === 'ROLE_ADMIN' &&
							<div>
								<Link to = '/statistics'>
									{'Statistik'}
								</Link>
							</div>}

						{/* profile-link for trainers */}
						{userData.role === 'ROLE_TRAINER' &&
							<div>
								<Link to = '/profile'>
									{'Profil'}
								</Link>
							</div>}
						<div>
							<Link to = '/changePassword'>
								{'Passwort ändern'}
							</Link>
						</div>
						<div>
							<a href = {'/logout'} onClick = {onLogout}>
								{'Abmelden'}
							</a>
						</div>
					</nav>
				</Col>
				{userData.license.displayName !== 'Administrator' &&
					<Col className = {'col-2'}>
						<div>
							<h2>{`Lizenz: ${userData.license.displayName}`}</h2>
						</div>
					</Col>}
			</>
		);
	}
	else
		topleft = (
			<Switch>
				{/* imprint / privacy */}
				<Route path = {['/impressum', '/datenschutz']}>
					<Col>
						<a href = {'/'}>
							{'Zurück'}
						</a>
					</Col>
				</Route>

				{/* login */}
				<Route>
					<Col>
						<h4>Herzlich willkommen<br/><br/>
							Sie befinden sich auf der Anmeldeseite der<br/>
							Kairos Software</h4>
					</Col>
				</Route>
			</Switch>
		);



	// render

	return (
		<Row className = {'justify-content-between'}>
			{topleft}
			<Col xs={'auto'}>
				{banner}
			</Col>
		</Row>
	);
};
